export function setCookie(name, value, days) {
    utils.consoleLog('COOKIES', `Setze Cookie: ${name}=${value}, gültig für ${days} Tage`);

    let expires = "";
    if (days) {
        const DATE = new Date();
        DATE.setTime(DATE.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + DATE.toUTCString();
        utils.consoleLog('COOKIES', `Cookie Ablaufdatum: ${expires}`);
    }

    document.cookie = `${name}=${value || ""}${expires}; path=/; Secure; SameSite=Lax`;
    utils.consoleLog('COOKIES', `Cookie gesetzt: ${document.cookie}`);
}

// Cookie-Funktion zum Abrufen eines Cookies
export function getCookie(name) {
    utils.consoleLog('COOKIES', `Suche nach Cookie mit Namen: ${name}`);

    const NAME_EQ = name + "=";
    const COOKIES = document.cookie.split(";");
    for (let i = 0; i < COOKIES.length; i++) {
        let c = COOKIES[i].trim();
        utils.consoleLog('COOKIES', `Prüfe Cookie: ${c}`);

        if (c.indexOf(NAME_EQ) === 0) {
            const FOUND_VALUE = c.substring(NAME_EQ.length);
            utils.consoleLog('COOKIES', `Cookie gefunden: ${name}=${FOUND_VALUE}`);
            return FOUND_VALUE;
        }
    }

    utils.consoleLog('COOKIES', `Cookie ${name} nicht gefunden`);
    return null;
}
